import ApiFetchers from "@/apis/api_fetchers"
import AppSignals from "@/features_signal/app"
import { createLogger } from "@/utils/logger"
import { isArray, uniqBy } from "lodash"
import { useCallback, useEffect, useState } from "react"
import { toast } from "react-toastify"

export interface RechargeChannel {
    id: string
    name: string
    min_amount: string
    max_amount: string
    img: string
    amount_limit: string[]
    tips: string
}

export interface LaCode {
    name: string
    price: string
    img: string
    link: string
}

const logger = createLogger("search-action-layout")

export default () => {
    const [selectedChannel, setSelectedPaymentMethod] = useState<RechargeChannel>()
    const [channels, setChannels] = useState<RechargeChannel[]>([])
    const [laCodeList, setLaCodeList] = useState<LaCode[]>([])

    const getFinanceLaList = useCallback(async () => {
        const response = await ApiFetchers.refGetFinanceLaList()
        logger.debug("getFinanceLaList", response)
        if (isArray(response)) {
            // @ts-ignore
            setLaCodeList(response)
        }
    }, [])

    const getFinanceChannelList = useCallback(async () => {
        const response = await ApiFetchers.refGetFinanceChannelList({ mode: "1" })
        logger.debug("refGetFinanceChannelList", response.data)
        // 发现配置有id重复问题
        const uniqueChannels = uniqBy<RechargeChannel>(
            isArray(response.data) ? response.data : [],
            "id",
        )
        if (uniqueChannels.length > 0) {
            setChannels(uniqueChannels)
            if (AppSignals.isMayaminiUser()) {
                uniqueChannels.map((channel, index) => {
                    if (channel.name === "maya-mini") {
                        setSelectedPaymentMethod(uniqueChannels[index])
                    }
                })
            } else if (AppSignals.isLazadaminiUser()) {
                uniqueChannels.map((channel, index) => {
                    if (channel.name === "lazada-mini") {
                        setSelectedPaymentMethod(uniqueChannels[index])
                    }
                })
            } else {
                setSelectedPaymentMethod(uniqueChannels[0])
            }
        } else {
            toast.error("No payment methods available")
            setChannels([])
        }
    }, [])

    useEffect(() => {
        getFinanceLaList()
        getFinanceChannelList()
    }, [getFinanceLaList, getFinanceChannelList])

    useEffect(() => {
        if (selectedChannel?.id.toString() === "1008") {
            getFinanceLaList()
        }
    }, [selectedChannel, getFinanceLaList])

    return {
        laCodeList,
        selectedChannel,
        channels,
        setSelectedPaymentMethod,
        getFinanceChannelList,
    }
}
